import React, { Component } from 'react'
import PropTypes from 'prop-types';

export default class ImageButton extends Component {
    render() {
        return (
            <div
                style={this.props.style}
                className={this.props.className}
            >
                <img
                    type="button"
                    className="button"
                    loading="eager"
                    alt={this.props.alt}
                    src={this.props.src}
                    onClick={(e)=>{
                        e.preventDefault();
                        if(!this.props.disabled) 
                            this.props.onClick()
                    }}
                    selectable="false"
                    onMouseDown={(e)=>{e.preventDefault(); e.stopPropagation();}}
                    title={this.props.alt}
                ></img>
            </div>
        )
    }

    static propTypes = {
        alt: PropTypes.string.isRequired,
        src: PropTypes.string.isRequired
    };
}
